import { combineReducers } from 'redux';
import formChangeStatusReducer from './form-change-status';
import formCommentReducer from './form-comment';
import searchResultReducer from './search-result';
import formSearchReducer from './form-search';
import formManagerReducer from './form-manager';
import formPrepareDocReducer from './form-prepare-doc';
import templatesReducer from './form-prepare-doc-template';

const legislativeProcessesReducer = combineReducers({
  formChangeStatus: formChangeStatusReducer,
  formComment: formCommentReducer,
  searchResult: searchResultReducer,
  formSearch: formSearchReducer,
  formManager: formManagerReducer,
  formPrepareDoc: formPrepareDocReducer,
  templates: templatesReducer,
});

export default legislativeProcessesReducer;
